import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import MTable, { MTableBodyRow } from 'material-table';
import { Paper, TablePagination } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const SavedQueriesTable = (props) => {
  const [selectedQuery, setSelectedQuery] = useState(null);
  const {t}=useTranslation();

  if (! props.savedQueries) {
    return "";
  }

  const onClickRow = (rowdata) => {
    setSelectedQuery(rowdata);
    props.onSelectRow(rowdata);
  }

  const columnDefinition=[
    { title: t('name'), field: 'name' },
    { title: t('creationDate'), field: 'date' },
  ];

  const tableRows=Object.keys(props.savedQueries).map( (name)=>props.savedQueries[name] ).filter( 
    (q) => props.filter==="" || (q.name+q.keywords).match(props.filter) 
  );

  return (
    <div>
      <Paper>
        <MTable
            title={" "}
            columns={columnDefinition}
            data={tableRows}
            options={{
              filtering: true,
              search: true,
              sorting: true,
              exportButton: true,
              exportFile: 'personalCorpus',
              exportAlldata: true,
              pageSize:5,
              padding: 'dense',
              rowStyle: (rowData) => ({
                backgroundColor: ( selectedQuery && selectedQuery.name === rowData.name ) ? '#EEE' : '#FFF',
                height:'35px',
                maxHeight:'35px',
              })

            }}
            components={{
              Pagination: paginationProps => (
                <TablePagination
                  {...paginationProps}
                  rowsPerPageOptions={[ 10, 25, 50, 100, tableRows.length ]}
                />
              ),
              Container: props => (
                <Paper
                  {...props}
                  elevation={0}
                />
              ),
              Row: rowProps => (
                <MTableBodyRow
                  {...rowProps}
                  onRowClick = {(e,rowData) => onClickRow(rowData)}
                />
              )
            }}
        />
      </Paper>
    </div>
  );
};

SavedQueriesTable.propTypes = {
  savedQueries: PropTypes.object,
  onSelectRow: PropTypes.func,
  filter:PropTypes.string,
};

export default withTranslation()(SavedQueriesTable);
